module.exports = __webpack_public_path__ + "img/hong1.6def6148.png";